<template>
  <div class="accessControlGateList w-full h-full relative">
    <div class="icon-search__input mt-5px mb-5px">
      <el-input class="w-full" placeholder="请输入设备名称" v-model="keyWords" clearable>
        <i slot="append" class="el-icon-search cursor-pointer" @click="getDeviceList"></i>
      </el-input>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 100px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      @row-click="toLocation"
      row-key="id"
    >
      <el-table-column :label="`${$t('设备名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('类型')}`" show-overflow-tooltip prop="deviceTypeDesc" width="80">
      </el-table-column>
      <!-- <el-table-column
        :label="`${$t('所属区域')}`"
        show-overflow-tooltip
        prop="areaCode"
      ></el-table-column> -->
      <el-table-column label="状态" show-overflow-tooltip prop="status" width="80">
        <template #default="{ row }">
          <div v-if="row.status === 0">未知</div>
          <div v-if="row.status === 1">在线</div>
          <div v-if="row.status === 2">离线</div>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15 cursor-pointer text-[#00BCC8]" @click="reviewDetail(row, true)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getDeviceList()"
      :pager-count="5"
    >
    </el-pagination>
    <DccessRecordDialog
      :deviceId="deviceId"
      :deviceType="deviceNum"
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px"
    ></DccessRecordDialog>
  </div>
</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { WisdomSecurityApi } from '@wiz-api/huizhou2'
import { Tag3DPositionApi, Tag3DPositionImgApi } from '@wiz-api/tag-3d-position-management'
import { findIndex } from 'lodash'

const wisdomSecurityApi = new WisdomSecurityApi()
const dataCategoryApi = new DataCategoryApi()
const tag3DPositionManagementAPI = new Tag3DPositionApi()
const tag3DPositionImgApi = new Tag3DPositionImgApi()
const DccessRecordDialog = () => {
  return import('./accessRecordDialog')
}
export default {
  name: 'DigitalEngineering',
  components: {
    DccessRecordDialog,
  },
  props: {
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
    cloudRender: {
      type: Object,
      defalut: null,
    },
    customProps: {
      type: Object,
      defalut: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 15,
      pageNo: 1,
      isShowDialog: false,
      keyWords: '',
      deviceId: '',
      deviceNum: 2,
      deviceTypeList: [],
      deviceType: '',
      basicIconList: [], // 基础图标集合,用于找出该摄像头设置的图标名称
      iconTypeList: [],
      basicImgType: '',
      guardMarkerList: [], // 三维里需要显示的门禁道闸集合
      cameraMarkerIds: [],
      textMarkerIds: [],
      markerTableData: [],
    }
  },
  watch: {
    guardMarkerList(val) {
      console.log('guardMarkerList', val)
      this.delMarkers()
      this.delTextMarkers()
      this.createCameraMarker()
      if (Array.isArray(val) && val.length > 0) {
        val.forEach((item) => {
          this.createTextMakers(item)
        })
      }
    },
    'transferProps.deviceId': {
      handler(val) {
        if (val) {
          this.reviewDetail(this.transferProps)
        }
      },
      deep: true,
    },
  },
  computed: {
    // 驾驶舱配置
    modelSetting() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config') || {}
      )
    },
    // 图标的最大可见距离
    maxLod() {
      return _.get(this.modelSetting, 'cameraDistanceConfig.maxLod') || null
    },
    // 图标的最大可见距离
    minLod() {
      return _.get(this.modelSetting, 'cameraDistanceConfig.minLod') || null
    },
  },
  created() {
    if (this.transferProps?.deviceId) {
      this.reviewDetail(this.transferProps)
    }
  },
  async mounted() {
    this.switchMarker(true)
    await this.getDeviceType()
    await this.getCategoryByCodes()
    await this.getBasicIconList()
    this.getGuardHasPosition()
  },
  methods: {
      // 关闭/开启标记
    switchMarker(show) {
      const event = new CustomEvent('setLabelChecked', {
        detail: {
          code: 'BarrierList',
          checked: show,
        },
      })
      window.dispatchEvent(event)
    },
    async getDeviceList() {
      const [err, res] = await wisdomSecurityApi.getIotDevicePagedList({
        body: {
          maxResultCount: this.pageSize,
          skipCount: (this.pageNo - 1) * this.pageSize,
          DeviceType: _.get(this.modelSetting, 'cockpitDyw.config.accessRefer') || [3],
          areaCode: '',
          keyWords: this.keyWords,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    async reviewDetail(item, needToLocate = false) {
      this.isShowDialog = true
      this.deviceId = item.deviceId
      this.deviceNum = item.deviceType === 'AccessControl' ? 2 : 3
      // 只对列表点击查看详情做定位，其他情况已有定位操作，避免重复
      if (needToLocate && this.player) {
        const str = sessionStorage.getItem('barrierMarkList')
        if (str && JSON.parse(str).length) {
          const markList = JSON.parse(str)
          const index = findIndex(markList, ['id', item.deviceId])
          if (index > -1) {
            const treeData = await this.player.Native.ModelTree.getRootItems()
            this.player?.Native.Camera.moveToPos(
              JSON.parse(markList[index].threeDPosition),
              treeData[0]?.nodePtr,
              50,
              2
            )
          }
        }
      }
    },
    refresh() {
      this.isShowDialog = false
    },
    // 获取设备类型
    async getDeviceType() {
      const [err, res] = await tag3DPositionManagementAPI.getTag3DPositionTagTypeList()
      if (!err) {
        const deviceTypeList = res || []
        this.deviceTypeList = deviceTypeList
        const queryName = 'IOTDeviceAccessControl'
        const findItem = deviceTypeList.find((n) => {
          return n.code.includes(queryName)
        })
        this.deviceType = (findItem && findItem.code) || queryName
      }
    },
    // 数据字典获取图标类型
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['Tag3DPositionImgType'],
        includeDetails: true,
      })
      if (!err) {
        this.iconTypeList = res[0] && res[0].dataItems
        const findBasicItem = _.find(this.iconTypeList, (item) => {
          return item.code.toLowerCase() === 'base'
        })
        this.basicImgType = findBasicItem && findBasicItem.id
      }
    },
    // 获取基础图标列表
    async getBasicIconList() {
      if (this.basicImgType && this.deviceType) {
        const [err, res] = await tag3DPositionImgApi.findPagedTag3DPositionImgsList({
          imgType: this.basicImgType, // 必传
          tagTypeCode: this.deviceType, // 必传
          skipCount: 0,
          maxResultCount: 1000,
        })
        if (!err) {
          this.basicIconList = res && res.items
          this.getDeviceList()
        }
      }
    },
    // 获取已标记的门禁道闸数据
    async getGuardHasPosition() {
      const [err, res] = await wisdomSecurityApi.getIotDevicePagedList({
        body: {
          isOnlyHas3DInfo: true,
          DeviceType: _.get(this.modelSetting, 'cockpitDyw.config.accessRefer') || [3],
        },
      })
      if (!err) {
        this.markerTableData = res.items || []
        if (this.player && this.player.Native) {
          this.guardMarkerList = []
          this.handleGuardData()
        }
      }
    },
    // 处理门禁列表数据显示在三维里
    handleGuardData() {
      const list = this.markerTableData.filter((item) => {
        return item.tag3DPositionDto
      })
      console.log(list, 'bbb')
      // 摄像头标记信息
      const guardMarkerList = list.map((val) => {
        return {
          name: val.deviceName,
          pos:
            (val.tag3DPositionDto.threeDPosition &&
              JSON.parse(val.tag3DPositionDto.threeDPosition)) ||
            [],
          code: val.deviceCode,
          cameraId: val.deviceId,
          tagFileImgId: val.tag3DPositionDto?.tagFileImgId,
          manufacturerCode: val.manufacturerCode,
          pIid: val.pIid,
        }
      })
      this.guardMarkerList = guardMarkerList
    },
    // 创建摄像头标记
    createCameraMarker() {
      console.log(this.guardMarkerList, '000000')
      this.guardMarkerList.forEach(async (val) => {
        const basicIconInfo = this.basicIconList.find((item) => {
          return item.id === val.tagFileImgId
        })
        console.log(basicIconInfo, 'basicIconInfobasicIconInfo')
        const iconName = basicIconInfo && basicIconInfo.originalFileName
        this.player.Native.GisMarker.loadImage(
          `data://apps/gat/img/${iconName || 'icon-camara-blue.png'}`,
          (id) => {
            const option = {
              pos: val.pos, // 定位点，世界坐标，三维向量
              nodeOffset: [0, -40], // 相对定位点的偏移量，二维向量
              imgId: id, // 图片id
              imgSize: [32, 46],
              visible: true,
            }
            if (this.maxLod) option.maxLod = this.maxLod
            if (this.minLod) option.minLod = this.minLod
            this.player.Native.GisMarker.create(option, (markerId) => {
              this.cameraMarkerIds.push({
                markerId,
                type: val.deviceType,
                code: val.code,
                name: val.name,
                cameraId: val.cameraId,
                manufacturerCode: val.manufacturerCode,
                pIid: val.pIid,
              })
            })
          }
        )
      })
    },
    // 创建文本标记
    createTextMakers(item) {
      this.player.Native.GisMarker.loadImage(item.imgBackgroundColor || 'rgba:0,0,0,135', (id) => {
        const nameLength = item.name.length
        const textRows = Math.ceil((nameLength * 15) / 150)
        const imgHeight = textRows * 15 + 10
        const option = {
          pos: item.pos, // 定位点，世界坐标，三维向量
          nodeOffset: [32, -(32 + 15 * (textRows - 1))], // 相对定位点的偏移量，二维向量
          imgId: id, // 图片id
          imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
          text: item.name || '', // 文本
          textFontSize: 15.0, // 字体大小
          breakWidth: 150, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          textColor: 0xffffffff, // 文本颜色
          title: null, // 标题
          contentPadding: [5, 5, 5, 5],
        }
        if (this.maxLod) option.maxLod = this.maxLod
        if (this.minLod) option.minLod = this.minLod
        this.player.Native.GisMarker.create(option, (markerId) => {
          this.textMarkerIds.push({
            markerId,
          })
        })
      })
    },
    // 定位位置
    toLocation(row) {
      console.log('row', row)
      if (row.tag3DPositionDto && row.tag3DPositionDto.threeDAngleView) {
        const cameraParams = JSON.parse(row.tag3DPositionDto.threeDAngleView)
        this.player.Native.Camera.moveTo(cameraParams.eye, cameraParams.target, cameraParams.up, 2)
      }
    },
    // 删除图标标记
    delMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.cameraMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.cameraMarkerIds = []
    },
    // 删除名称标记
    delTextMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.textMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.textMarkerIds = []
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.player.Native.Camera.moveTo(cameraParams.eye, cameraParams.target, cameraParams.up, 2)
      }
    },
  },
  beforeDestroy() {
    this.delMarkers()
    this.delTextMarkers()
    this.backInitPositon()
    this.switchMarker(false)
  },
}
</script>
<style lang="scss" scoped></style>
